import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';

import * as rawJSONSchemaModuleSurgerySpinal from '../../schemas/module-surgery-spinal.json';

class ModuleValueSurgerySpinal extends ModuleValueGeneral {
}

export class SchemaModuleSurgerySpinal extends SchemaModuleGeneral<ModuleValueSurgerySpinal> {
  schema: JSONSchema<ModuleValueSurgerySpinal>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleSurgerySpinal );
  }

  hook( form: FormComponent ) {
    super.hook( form );
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-surgery-spinal.ts